import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelUser } from "@src/types/user-management";

export interface GetSupportAgentsResult {
  success: boolean;
  data?: ZitadelUser[];
  error?: string;
}

export const getSupportAgentsUseCase =
  async (): Promise<GetSupportAgentsResult> => {
    try {
      const namespace =
        store.getState().yourSlice.authContext.customerNamespace;
      const response = await apiUseCases.getSupportAgents(namespace);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: parseAxiosApiError(error, "Failed to fetch support agents")
          .message,
      };
    }
  };
